import React from "react";
import GenericErrorPage from "./GenericErrorPage";

export default () => (
  <GenericErrorPage
    src="https://http.cat/401"
    alt="Unauthorized"
    heading="Unauthorized Access"
    description="You are not authorized to access this page. Try logging in."
  />
);
